/**
 * dir-w | backOffice
 * Page Properties Component page to display a spinner for waiting a process
 * and any result [`success`|`error`|`normal`] after a process is completed / finished
 *
 * Last update : August 8, 2024 | @rizkiprasetya
*/

import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { enumPageMode, enumPageResult } from '../../app.enum';
import { Configuration } from '../../config/configuration';

@Component({
    selector: 'app-page-properties',
    templateUrl: './page-properties.component.html',
    styleUrl: './page-properties.component.css',
    standalone: false
})
export class PagePropertiesComponent {
  protected _enumPageMode = enumPageMode;
  protected _enumPageResult = enumPageResult;

  // get the image based on active profile on `Configuration`
  protected profilePath: string = `/assets/profile/${Configuration.Profile}/images/background.png`;

  @Input() mode: enumPageMode = enumPageMode.LOADING; // show default loading
  @Input() result: enumPageResult = enumPageResult.NORMAL;
  @Input() title: string = '';
  @Input() header: string = '';
  @Input() content: string = '';
  @Input() useButton: boolean = false;
  @Input() buttonCaption: string = 'Return';
  @Input() targetUrl: string = '/';
  @Input() targetUrlParams: any = null;

  constructor(private _router: Router) {}

  /**
   * If page status display a button, this procedure is to handle the process reload the same page (url)
   */
  buttonOnClick(): void {
    // need to redirect to anywhere else so we can reload the page component
    // window.location.reload();
    this._router
      .navigateByUrl('/loading', { skipLocationChange: true })
      .then(() => {
        if (this.targetUrlParams === null) {
          this._router.navigate([this.targetUrl]);
        } else {
          this._router.navigate([this.targetUrl], {
            queryParams: this.targetUrlParams,
          });
        }
      });
  }
}
